"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _APButton = _interopRequireDefault(require("../../common/APButton"));
var _reactRouter = require("react-router");
var _config = require("../../../config");
var _routeTemplates = require("../../../routeTemplates");
var _path = _interopRequireDefault(require("../../../helpers/path"));
var _APSelect = _interopRequireDefault(require("../../common/APSelect"));
var _APIcon = _interopRequireDefault(require("../../common/APIcon"));
var _ContentWithHeaderLayoutTemplate = _interopRequireDefault(require("../../common/LayoutTemplates/ContentWithHeaderLayoutTemplate/ContentWithHeaderLayoutTemplate"));
require("./DemoSettingsEditableComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var demoSettingsClasses = (0, _cssClassesHelper.getBEMClasses)('demo-settings');
var demoSettingsWidgetsClasses = (0, _cssClassesHelper.getBEMClasses)('demo-settings-widget');
var DemoSettingsComponent = /*#__PURE__*/function (_React$Component) {
  function DemoSettingsComponent() {
    var _this;
    _classCallCheck(this, DemoSettingsComponent);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, DemoSettingsComponent, [].concat(args));
    _defineProperty(_this, "handleSubmit", function (event) {
      var formValues = _this.props.formValues;
      localStorage.setItem('apexTemplate', JSON.stringify(formValues));
      event.preventDefault();
      _this.reloadConfigAndRefresh();
    });
    _defineProperty(_this, "clearApexTemplateInLocalStorage", function (event) {
      localStorage.setItem('apexTemplate', JSON.stringify({}));
      event.preventDefault();
      _this.reloadConfigAndRefresh();
    });
    _defineProperty(_this, "reloadConfigAndRefresh", function () {
      (0, _config.assignConfigWithLocal)();
      (0, _routeTemplates.AssignRoutes)();
      _this.props.history.push((0, _path["default"])('/login'));
      window.location.reload();
    });
    _defineProperty(_this, "getLayoutHeader", function () {
      var t = _this.props.t;
      var goToStep = _this.props.goToStep;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: demoSettingsWidgetsClasses('header')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: demoSettingsWidgetsClasses('header-text')
      }, t("Edit Settings")), /*#__PURE__*/_react["default"].createElement("div", {
        onClick: function onClick() {
          return goToStep(0);
        }
      }, /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
        name: "close",
        customClass: demoSettingsWidgetsClasses('icon'),
        classModifiers: "big"
      })));
    });
    _defineProperty(_this, "getTemplateOptions", function () {
      return [{
        value: 'NEWYORK',
        label: 'New York'
      }, {
        value: 'MILAN',
        label: 'Milan'
      }, {
        value: 'LONDON',
        label: 'London'
      }];
    });
    _defineProperty(_this, "getThemeOptions", function () {
      return [{
        value: 'dark',
        label: 'Dark'
      }, {
        value: 'light',
        label: 'Light'
      }];
    });
    _defineProperty(_this, "getChartOptions", function () {
      return [{
        value: 'APEX',
        label: 'APEX'
      }, {
        value: 'TradingView',
        label: 'TradingView'
      }];
    });
    return _this;
  }
  _inherits(DemoSettingsComponent, _React$Component);
  return _createClass(DemoSettingsComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
        formValues = _this$props.formValues,
        change = _this$props.change;
      var fieldsOptions = {
        template: this.getTemplateOptions(),
        theme: this.getThemeOptions(),
        chart: this.getChartOptions()
      };
      Object.keys(fieldsOptions).forEach(function (field) {
        if (!formValues[field]) {
          var value = fieldsOptions[field][0].value;
          change(field, value);
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var t = this.props.t;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: demoSettingsClasses()
      }, /*#__PURE__*/_react["default"].createElement(_ContentWithHeaderLayoutTemplate["default"], {
        header: this.getLayoutHeader(),
        customClass: demoSettingsWidgetsClasses()
      }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("form", {
        className: demoSettingsClasses('form')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: demoSettingsClasses('content-holder')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: demoSettingsClasses('row')
      }, /*#__PURE__*/_react["default"].createElement(_APSelect["default"], {
        name: "template",
        label: t("Template"),
        customClass: demoSettingsClasses(),
        options: this.getTemplateOptions()
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: demoSettingsClasses('row')
      }, /*#__PURE__*/_react["default"].createElement(_APSelect["default"], {
        name: "theme",
        label: t("Color Theme"),
        customClass: demoSettingsClasses(),
        options: this.getThemeOptions()
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: demoSettingsClasses('row')
      }, /*#__PURE__*/_react["default"].createElement(_APSelect["default"], {
        name: "chart",
        label: t("Chart Type"),
        customClass: demoSettingsClasses(),
        options: this.getChartOptions()
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: demoSettingsClasses('row')
      }, /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
        customClass: demoSettingsClasses(),
        onClick: this.handleSubmit
      }, "Apply"), /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
        customClass: demoSettingsClasses(),
        onClick: this.clearApexTemplateInLocalStorage
      }, "Clear")))))));
    }
  }]);
}(_react["default"].Component);
var _default = exports["default"] = (0, _reactRouter.withRouter)((0, _reactI18next.withTranslation)("user")(DemoSettingsComponent));